<template>
  <div class="bottom-nav">
    <router-link to="/" class="nav-item" active-class="active">
      <img :src="currentRoute === '/' ? homeOnIcon : homeIcon" alt="首页" />
      <span>首页</span>
    </router-link>
    <router-link to="/me" class="nav-item" active-class="active">
      <img :src="currentRoute === '/me' ? meOnIcon : meIcon" alt="我的" />
      <span>我的</span>
    </router-link>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import homeIcon from '../assets/icon/home.svg'
import homeOnIcon from '../assets/icon/home_on.svg'
import meIcon from '../assets/icon/me.svg'
import meOnIcon from '../assets/icon/me_on.svg'

export default {
  name: 'BottomNav',
  setup() {
    const route = useRoute()
    const currentRoute = computed(() => route.path)

    return {
      currentRoute,
      homeIcon,
      homeOnIcon,
      meIcon,
      meOnIcon
    }
  }
}
</script>

<style scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 56px; /* 增加高度使触摸更容易 */
  background: #ffffff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.1);
  padding-bottom: env(safe-area-inset-bottom); /* 适配iPhone X等带有底部安全区域的设备 */
  z-index: 1000;
  max-width: 550px; /* 与主内容区域保持一致 */
  margin: 0 auto; /* 在宽屏设备上居中显示 */
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #999;
  font-size: 12px;
  padding: 4px 0;
  flex: 1;
  transition: all 0.3s ease;
  -webkit-tap-highlight-color: transparent; /* 移除点击高亮 */
  position: relative;
  height: 100%;
}

.nav-item img {
  width: 24px;
  height: 24px;
  margin-bottom: 3px;
  transition: all 0.3s ease;
}

.nav-item span {
  line-height: 1.2;
  transform: scale(0.95); /* 稍微缩小文字 */
}

.nav-item.active {
  color: #1296db;
  font-weight: 500;
}

.nav-item.active img {
  transform: scale(1.1); /* 激活时图标稍微放大 */
}

/* 添加点击反馈 */
.nav-item:active {
  opacity: 0.7;
}

/* 适配不同屏幕尺寸 */
@media screen and (min-width: 550px) {
  .bottom-nav {
    border-radius: 16px 16px 0 0; /* 在宽屏设备上添加圆角 */
  }
}

@media screen and (max-width: 320px) {
  .nav-item {
    font-size: 10px; /* 在小屏设备上缩小字体 */
  }
  
  .nav-item img {
    width: 22px;
    height: 22px;
  }
}
</style> 